import Storage from './storage';

const storage = new Storage([
  { key: 'autoplay' },
  { key: 'playFromStart' },
  { key: 'epgTab' },
  { key: 'socialMedia' },
  { key: 'ipressoContact' },
  { key: 'isKidsMode' },
  { key: 'language' },
  { key: 'mute' },
  { key: 'onboarding' },
  { key: 'playerAudio' },
  { key: 'playerProfile' },
  { key: 'playerSubtitle' },
  { key: 'routerPreviousName', session: true },
  { key: 'sortOption' },
  { key: 'volume' },
]);

export { storage };

export default (ctx, inject) => {
  inject('storage', storage);
};
